// src/utils/fetchCourses.js


/**
* Saves course data to localStorage.
*
* @param {string} major - The major name.
* @param {Array} courseData - The array of course data to save.
*/
export const saveCourseDataToLocalStorage = (major, courseData, fetchedMajors) => {
  try {
    const courseDataJSON = JSON.stringify(courseData);
    localStorage.setItem(`courseData-${major}`, courseDataJSON);
  } catch (error) {
    console.error('Error saving course data to local storage:', error);
  }
 };
 
 
 /**
 * Retrieves course data from localStorage.
 *
 * @param {string} major - The major name.
 * @returns {Array|null} - Returns the course data array or null if not found.
 */
 export const getCourseDataFromLocalStorage = (major) => {
  try {
    const courseDataJSON = localStorage.getItem(`courseData-${major}`);
    return courseDataJSON ? JSON.parse(courseDataJSON) : null;
  } catch (error) {
    console.error('Error retrieving course data from local storage:', error);
    return null;
  }
 };
 
 
 /**
 * Fetches courses for a given major from the `fetchedMajors` object
 * (which should already contain all of the major’s course data).
 *
 * @param {string | string[]} major - The major(s) to fetch courses for.
 * @param {Array} fetchedCourseData - Array of fetched course data used to look up Credits, Description, etc.
 * @param {object} fetchedMajors - An object containing data for each major, with each major's key mapping to its courses.
 * @returns {Promise<Array>} - Returns a promise that resolves to an array of course objects.
 */
 export const fetchCoursesFromDatabase = async (major, fetchedCourseData, fetchedMajors) => {
  try {
    // If major is an array (for combined majors), handle that scenario
    // by merging results. If it’s a single string, make it an array of length 1.
    const majorsToProcess = Array.isArray(major) ? major : [major];
    let allCourses = [];
 
 
    for (const singleMajor of majorsToProcess) {
      // Check local storage first
      const courseDataFromLocalStorage = getCourseDataFromLocalStorage(singleMajor);
      if (courseDataFromLocalStorage) {
        console.log(`Retrieved course data for ${singleMajor} from localStorage.`);
        allCourses = allCourses.concat(courseDataFromLocalStorage);
        continue; // proceed to next major in the loop
      }
 
 
      // If not in local storage, build from fetchedMajors
      console.log('FM HI :DDDD: ', fetchedMajors, singleMajor);
      if (!fetchedMajors[singleMajor]) {
        console.warn(`No data found in fetchedMajors for major: ${singleMajor}`);
        continue;
      }
 
 
      const majorCourses = fetchedMajors[singleMajor]; // This is the object of course-number -> attributes
      if (typeof majorCourses !== 'object') {
        console.warn(`Invalid majorCourses data for major: ${singleMajor}`);
        continue;
      }
 
 
      // Helper functions
      const findCredits = (courseNumber) => {
        if (!courseNumber) return 0;
        const match = fetchedCourseData.find(
          (fetchedCourse) =>
            fetchedCourse.courseInfo_courseNumber === courseNumber
        );
        return match ? parseFloat(match.Credits) || 0 : 0;
      };
 
 
      const findName = (courseNumber) => {
        if (!courseNumber) return 'Unnamed Course';
        // If no direct naming found in the majorCourses object,
        // we check the global fetchedCourseData
        const match = fetchedCourseData.find(
          (fetchedCourse) =>
            fetchedCourse.courseInfo_courseNumber === courseNumber
        );
        return match ? match.courseInfo_courseName : 'Unnamed Course';
      };
 
 
      const findDescription = (courseNumber) => {
        if (!courseNumber) return 'No Description Available';
        const match = fetchedCourseData.find(
          (fetchedCourse) =>
            fetchedCourse.courseInfo_courseNumber === courseNumber
        );
        return match ? match.Description : 'No Description Available';
      };
      console.log('MajorCourses: ', majorCourses);
 
 
      // Iterate over each course in the major
      const courseIdsForThisMajor = Object.entries(majorCourses).map(
        ([courseNumber, courseData]) => {
          return {
            CourseSem: courseData.CourseSem || null,
            Credits: findCredits(courseNumber),
            cal_name: courseData.cal_name || '',
            courseCat: courseData.courseCat || '',
            courseInfo_courseName: findName(courseNumber),
            courseInfo_courseNumber: courseNumber,
            courseYear: courseData.courseYear || 1,
            max_capacity: courseData.max_capacity || null,
            sectionInfo_sectionNumber: courseData.sectionInfo_sectionNumber || null,
            sectionInfo_teacherDisplay: courseData.sectionInfo_teacherDisplay || null,
            isAutoFill: courseData.isAutoFill || false,
            isPrereqMet: true, // Assuming prerequisites are met by default
            Prerequisites: '',
            Corequisites: '',
            Instructor: courseData.Instructor || '',
            Major: courseData.Major || singleMajor,
            Possibilities: courseData.Possibilities,
            Description: findDescription(courseNumber),
            Requirements: courseData.Requirements.split(', ') || null,
            TransferPlan: courseData.TransferPlan || '',
            Name: courseData.Name || '',
            courseType: courseData.courseType || '',
            degreeName: singleMajor,
          };
        }
      );
 
 
      // Save to local storage for that major
      saveCourseDataToLocalStorage(singleMajor, courseIdsForThisMajor);
 
 
      // Merge these courses into the overall array
      allCourses = allCourses.concat(courseIdsForThisMajor);
     
    }
 
 
    // Return the combined array for all requested majors
    console.log('SumBS: ', allCourses);
    return allCourses;
  } catch (error) {
    console.error('Error building course IDs from fetchedMajors data:', error);
    return [];
  }
 };
 
 
 
 